// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".x2U2sJwV5DFaj9AY\\+2-RXA\\=\\= {\n    display: flex;\n    flex-wrap: wrap;\n}\n.ZzrFnDI1ck98EhtD44nfGA\\=\\= {\n    margin: 0;\n    font-size: 0.7em\n}", "",{"version":3,"sources":["webpack://./src/dashboard/styles/MultiSelect.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,SAAS;IACT;AACJ","sourcesContent":[".chips {\n    display: flex;\n    flex-wrap: wrap;\n}\n.chip {\n    margin: 0;\n    font-size: 0.7em\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chips": "x2U2sJwV5DFaj9AY+2-RXA==",
	"chip": "ZzrFnDI1ck98EhtD44nfGA=="
};
export default ___CSS_LOADER_EXPORT___;
